import { Dialog, DialogProps } from '@sandtech-hub-monorepo/ui-kit';
import { useEffect, useState } from 'react';
import { SelectProgramManagementOption } from './SelectProgramManagementOption';
import { PauseProgram } from './PauseProgram';
import { DeferCourse } from './DeferCourse';
import { WithdrawProgram } from './WithdrawProgram';
import { ProgramEnrollment, SelectProgram } from './SelectProgram';
import { ClassEnrollmentStatus } from '@sandtech-hub-monorepo/ehub-client';

interface Props extends DialogProps {
  programEnrollments: ProgramEnrollment[];
}

export const UpdateCourseStatusDialog = ({
  programEnrollments,
  ...otherProps
}: Props) => {
  const [programEnrollment, setProgramEnrollment] =
    useState<ProgramEnrollment>();
  const [selectedState, setSelectedState] = useState<
    'select' | 'pause' | 'defer' | 'withdraw'
  >();

  useEffect(() => {
    if (!programEnrollment) {
      return;
    }
    if (programEnrollment.canPause || programEnrollment.canDefer) {
      setSelectedState('select');
    } else {
      setSelectedState('withdraw');
    }
  }, [programEnrollment]);

  const alreadyDeferred =
    programEnrollment?.plannedCourses
      .filter(
        ({ enrollment }) =>
          enrollment?.currentClass?.status === ClassEnrollmentStatus.Deferred
      )
      .map(({ enrollment }) => enrollment?.currentClass?.id.toString()) ?? [];

  useEffect(() => {
    if (!otherProps.open) {
      setSelectedState(undefined);
      setProgramEnrollment(undefined);
    } else if (programEnrollments.length === 1) {
      setProgramEnrollment(programEnrollments[0]);
    }
  }, [otherProps.open, programEnrollments]);

  return (
    <Dialog {...otherProps}>
      {!programEnrollment && (
        <SelectProgram
          programEnrollments={programEnrollments}
          onSelect={setProgramEnrollment}
        />
      )}
      {programEnrollment && (
        <>
          {selectedState === 'select' && (
            <SelectProgramManagementOption
              onPause={() => setSelectedState('pause')}
              canPause={programEnrollment.canPause}
              canWithdraw={programEnrollment.canWithdraw}
              canDefer={programEnrollment.canDefer}
              onDefer={() => setSelectedState('defer')}
              onWithdraw={() => setSelectedState('withdraw')}
            />
          )}
          {selectedState === 'pause' && (
            <PauseProgram
              programEnrollment={programEnrollment}
              alreadyDeferred={alreadyDeferred}
              onCancel={() => otherProps.onOpenChange!(false)}
            />
          )}
          {selectedState === 'defer' && (
            <DeferCourse
              programEnrollment={programEnrollment}
              onCancel={() => otherProps.onOpenChange!(false)}
              alreadyDeferred={alreadyDeferred}
            />
          )}
          {selectedState === 'withdraw' && (
            <WithdrawProgram
              programEnrollment={programEnrollment}
              onCancel={() => otherProps.onOpenChange!(false)}
            />
          )}
        </>
      )}
    </Dialog>
  );
};
